import { PRICING_URL, SUPPORT_EMAIL } from '@constants';
import * as Dialog from 'components/Widget/Dialog';
import PricingToggle from 'components/Widget/PricingToggle';
import TierCard from 'components/Account/TierCard';
import { Tier } from 'dragonmouse-shared/interfaces';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setPlanPricingModalVisible } from 'redux/mode/actions';
import * as S from './styles';

const PlanPricingModal = () => {
	const dispatch = useDispatch();
	const [isYearly, setIsYearly] = useState(true);

	//----------------------------------------------------------------------
	// HANDLERS
	//----------------------------------------------------------------------
	const onDismiss = () => {
		dispatch(setPlanPricingModalVisible(false));
	};

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------
	return (
		<Dialog.Root modal={true} open={true} onOpenChange={(open) => !open && onDismiss()}>
			<Dialog.Portal>
				<S.Overlay onClick={onDismiss}>
					<S.ModalContainer
						onClick={(e) => e.stopPropagation()}
						role="dialog"
						aria-labelledby="welcome-headline"
						aria-describedby="welcome-subheading"
					>
						<S.CloseButton onClick={onDismiss} aria-label="Close modal">
							×
						</S.CloseButton>

						<S.Header>
							<S.Headline id="welcome-headline">Choose Your Plan</S.Headline>
							<S.Subheading id="welcome-subheading">
								AI-powered design tools for your creative workflow
							</S.Subheading>
						</S.Header>

						<S.BillingToggle>
							<PricingToggle isYearly={isYearly} onChange={setIsYearly} />
						</S.BillingToggle>

						<S.PricingGrid>
							<TierCard variant="upgrade" tier={Tier.TIER_1} isYearly={isYearly} />
							<TierCard variant="upgrade" tier={Tier.TIER_2} isYearly={isYearly} />
						</S.PricingGrid>

						<S.TrialSection>
							<S.TrialText>
								Building something cool? Tell us about it at{' '}
								<a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
								<br />
								We give access to interesting projects.
							</S.TrialText>

							<S.SecondaryLinks>
								<S.SecondaryLink href={PRICING_URL} target="_blank" rel="noopener noreferrer">
									See all features
								</S.SecondaryLink>
								<S.LinkSeparator>•</S.LinkSeparator>
								<S.MaybeLater onClick={onDismiss}>Maybe later</S.MaybeLater>
							</S.SecondaryLinks>
						</S.TrialSection>
					</S.ModalContainer>
				</S.Overlay>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

export default PlanPricingModal;
